import ToolsToGoBeyond, { ToolsToGoBeyondProps } from "./ToolsToGoBeyond";

export { ToolsToGoBeyond, ToolsToGoBeyondProps };

export default ToolsToGoBeyond;
